// Temporary environment override for testing production mode
// Change this value to test different environments locally

export const ENVIRONMENT_OVERRIDE: 'development' | 'staging' | 'production' | null = 'development';

// Usage: Set to 'production' to see production mode
//        Set to 'staging' to see staging mode  
//        Set to 'development' to see development mode
//        Set to null to use default environment detection

// FEATURE GUARD DISABLED: Always use development environment to show all data
// This ensures the app works consistently across all environments (Chrome, commit, etc.)
